export const ms = {
  msg:
    {
      'username': 'Kata Nama',
      'password': 'Kata Laluan',
      'login': 'Masuk',
      'username_not_found': 'Sila masukkan Kata Nama',
      'password_not_found': 'Sila masukkan Kata Laluan',
      'error': 'Kata nama atau kata laluan tidak sah.',
      'changeLanguage': '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      'submit_button_text': 'Hantar',
      'enter': 'Masuk',
      'en': 'English',
      'ms': 'Bahasa Melayu',
      'zh': 'Chinese',
      'ta': 'Tamil',
      'km': 'Khmer',
      'th': 'Thai',
      'id': 'Bahasa Indonesia',
      'ar': 'Arabic',
      'blank_username_field': 'Sila masukkan kata nama.',
      'blank_password_field': 'Sila masukkan kata laluan.',
      'invalid_credentials': 'Kata nama atau kata laluan tidak sah.',
      'copyright': 'Dikuasakan oleh Global Psytech'
    }
}
